export const WIDTH = 7.4;
export const HEIGHT = 7.4;

export const OX = 37;
export const OY = 31;

export const DPI = 1 / 2.54;
